import React from 'react';
import { Button, Card, Space, Tag, Typography } from 'antd';
import { CalendarOutlined, DollarOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { formatAmount, formatDate } from '../../constants/marketplaceCheckout';
import { fill } from './searchText';

const { Text, Title } = Typography;

/**
 * Offre de travail dans les résultats de recherche. « Voir l'offre » ouvre la page des
 * travaux champêtres sur cette offre (/agri-jobs?offer=<id>), où se fait la candidature.
 */
const JobOfferResultCard = ({ offer, currency, t }) => {
    const navigate = useNavigate();
    return (
        <Card className="search-job-card" size="small">
            <Space direction="vertical" size={4} style={{ width: '100%' }}>
                <Title level={5} style={{ margin: 0 }}>{offer.title}</Title>
                <Space wrap size={8}>
                    {offer.workType && <Tag color="green">{offer.workType}</Tag>}
                    <Text type="secondary"><UserOutlined /> {offer.companyName}</Text>
                </Space>
                <Text>
                    <DollarOutlined /> {formatAmount(offer.dailyRate, offer.currency || currency)} {t.job_per_day}
                </Text>
                <Text type="secondary">
                    <CalendarOutlined /> {fill(t.job_dates, { start: formatDate(offer.startDate), end: formatDate(offer.endDate) })}
                </Text>
                <Text type="secondary">{fill(t.job_deadline, { date: formatDate(offer.applicationDeadline) })}</Text>
                <Button type="primary" onClick={() => navigate(`/agri-jobs?offer=${encodeURIComponent(offer.id)}`)}>
                    {t.job_view}
                </Button>
            </Space>
        </Card>
    );
};

export default JobOfferResultCard;
